"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeIdempotentArgsSchema = exports.makeIdempotentOptionsSchema = exports.rateLimitArgsSchema = exports.rateLimitOptionsSchema = exports.requireAccountArgsSchema = exports.authenticationArgsSchema = exports.authenticationArg1Schema = exports.noStatsArgsSchema = exports.statsArgsSchema = exports.statsOptionsSchema = exports.StatsImportance = exports.visibilityArgsSchema = exports.MAKE_IDEMPOTENT_EXTENSION_NAME = exports.RATE_LIMIT_EXTENSION_NAME = exports.REQUIRE_ACCOUNT_EXTENSION_NAME = exports.NO_STATS_EXTENSION_NAME = exports.STATS_EXTENSION_NAME = exports.AUTH_TYPES_EXTENSION_NAME = exports.VERSION_HANDLE_EXTENSION_NAME = void 0;
const zod_1 = require("zod");
const Auth_1 = require("./Auth");
// This file contains the schemas and types for the custom Network API decorators.
// The arguments of such decorators are internally processed as any tuples which are validated
// and mapped through zod schemas and transformers to their corresponding extension type.
// This allows to verify decorator arguments during compile time and guarantees a strongly typed
// system in sync with schema validation.
exports.VERSION_HANDLE_EXTENSION_NAME = "x-versions";
exports.AUTH_TYPES_EXTENSION_NAME = "x-auth-types";
exports.STATS_EXTENSION_NAME = "x-stats";
exports.NO_STATS_EXTENSION_NAME = "x-no-stats";
exports.REQUIRE_ACCOUNT_EXTENSION_NAME = "x-require-account";
exports.RATE_LIMIT_EXTENSION_NAME = "x-rate-limit";
exports.MAKE_IDEMPOTENT_EXTENSION_NAME = "x-idempotent";
// Declares the schemas and types for the @Visiblity decorator arguments and tsoa extension.
// A @Visibility decorator takes in an arbitrary number of version handles,
// but at least one needs to be specified.
exports.visibilityArgsSchema = zod_1.z.array(zod_1.z.string()).min(1);
// Declares the schemas and types for the @Stats decorator arguments and tsoa extension.
const statsTagSchema = zod_1.z.string().regex(new RegExp("^[a-zA-Z0-9_\\-:./]+$"));
const statsTagsSchema = zod_1.z.record(statsTagSchema, zod_1.z.string().optional());
var StatsImportance;
(function (StatsImportance) {
    StatsImportance["HIGH"] = "HIGH";
    StatsImportance["MEDIUM"] = "MEDIUM";
    StatsImportance["LOW"] = "LOW";
})(StatsImportance = exports.StatsImportance || (exports.StatsImportance = {}));
exports.statsOptionsSchema = zod_1.z
    .object({
    domain: zod_1.z.string().optional(),
    subDomain: zod_1.z.string().optional(),
    action: zod_1.z.string().optional(),
    importance: zod_1.z.nativeEnum(StatsImportance).optional(),
    tags: statsTagsSchema.optional(),
})
    .strict();
exports.statsArgsSchema = zod_1.z.tuple([exports.statsOptionsSchema]).transform((args) => {
    return args[0];
});
// Declares the schemas and types for the @NoStats decorator arguments and tsoa extension.
exports.noStatsArgsSchema = zod_1.z.tuple([]).transform(() => {
    return true;
});
// Declares the schemas and types for the @Authentication decorator arguments as well as
// corresponding tsoa extension for authentication. The @Authentication follows the @Security
// decorator signature and has two arguments, with the second being optional.
exports.authenticationArg1Schema = zod_1.z.array(zod_1.z.nativeEnum(Auth_1.AuthScope));
const authenticationTypeSchema = zod_1.z.record(zod_1.z.nativeEnum(Auth_1.AuthType), exports.authenticationArg1Schema);
const authenticationArg0Schema = zod_1.z.union([zod_1.z.nativeEnum(Auth_1.AuthType), authenticationTypeSchema]);
exports.authenticationArgsSchema = zod_1.z
    .union([
    zod_1.z.tuple([zod_1.z.nativeEnum(Auth_1.AuthType)]),
    zod_1.z.tuple([zod_1.z.nativeEnum(Auth_1.AuthType), zod_1.z.array(zod_1.z.nativeEnum(Auth_1.AuthScope))]),
    zod_1.z.tuple([zod_1.z.record(zod_1.z.nativeEnum(Auth_1.AuthType).optional(), zod_1.z.array(zod_1.z.nativeEnum(Auth_1.AuthScope)))]),
])
    .transform((args, ctx) => {
    if (typeof args[0] === "string") {
        if (args.length === 1) {
            if (Auth_1.AuthType.INVALID === args[0]) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: "Invalid arguments type for @Authentication decorator",
                });
            }
            return { [args[0]]: [] };
        }
        else {
            return { [args[0]]: args[1] };
        }
    }
    else {
        return args[0];
    }
});
// Declares the schemas and types for the @RequireAccount decorator arguments and tsoa extension.
exports.requireAccountArgsSchema = zod_1.z.tuple([]).transform(() => {
    return true;
});
// Declares the schemas and types for the @RateLimit decorator arguments and tsoa extension.
exports.rateLimitOptionsSchema = zod_1.z
    .object({
    points: zod_1.z.number().int().positive().describe("The rate limit of each key").optional(),
    duration: zod_1.z.number().int().positive().describe("Duration of rate limit window in seconds").optional(),
})
    .strict();
exports.rateLimitArgsSchema = zod_1.z
    .union([zod_1.z.tuple([exports.rateLimitOptionsSchema]), zod_1.z.tuple([])])
    .optional()
    .transform((args) => {
    return args?.length ? args[0] : undefined;
});
// Declares the schemas and types for the @MakeIdempotent decorator arguments and tsoa extension.
exports.makeIdempotentOptionsSchema = zod_1.z
    .object({
    ttl: zod_1.z.number().int().positive().describe("The ttl of a cached idempotent response").optional(),
})
    .strict();
exports.makeIdempotentArgsSchema = zod_1.z
    .union([zod_1.z.tuple([exports.makeIdempotentOptionsSchema]), zod_1.z.tuple([])])
    .transform((args) => {
    return args?.length ? args[0] : undefined;
});
//# sourceMappingURL=Decorators.js.map